import { render, staticRenderFns } from "./PaymentIndex.vue?vue&type=template&id=6ec0e015&scoped=true&"
import script from "./PaymentIndex.vue?vue&type=script&lang=js&"
export * from "./PaymentIndex.vue?vue&type=script&lang=js&"
import style0 from "./PaymentIndex.vue?vue&type=style&index=0&id=6ec0e015&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0e015",
  null
  
)

export default component.exports